/**
 * API Connection type constants and utilities.
 * Centralizes type checking for managed (API Hub) connectors.
 */

/** All ApiConnection-family node types that use swagger-based connector infrastructure */
const API_CONNECTION_TYPES = new Set([
  'ApiConnection',
  'ApiConnectionNotification',
  'ApiConnectionWebhook',
]);

/**
 * Check if a node type is an API Connection family type (uses managed connector infrastructure).
 * These types use swagger for operation definitions and connect via API Hub connections.
 */
export function isApiConnectionType(nodeType: string | undefined): boolean {
  return !!nodeType && API_CONNECTION_TYPES.has(nodeType);
}

/**
 * Strip numeric suffix from a connection reference name to derive a base
 * connector name candidate.
 *
 * e.g., "teams-1" -> "teams", "azureblob_2" -> "azureblob", "office365" -> "office365"
 *
 * Use sparingly. The connector identity should always come from
 * `connectionReferences[key].api.id` (which is hydrated from
 * `connections.json`). This helper is only safe for matching/grouping in
 * places that don't fetch the connector swagger from the result.
 */
export function stripConnectionSuffix(referenceName: string): string {
  return referenceName.replace(/[-_]\d+$/, '');
}


